import type { ReactNode } from "react";

export interface LabelGridProps {
  children: ReactNode;
  className?: string;
}

/** Label-grid ruling: rows divided by hairlines, never a card grid. */
export function LabelGrid({ children, className = "" }: LabelGridProps) {
  return (
    <ul className={`divide-y divide-hairline border-y border-hairline ${className}`}>{children}</ul>
  );
}

export interface LabelGridRowProps {
  /** CSS grid-template-columns for the row, e.g. "3rem 1fr auto". Responsive rows set it per breakpoint in the caller. */
  columns?: string;
  children: ReactNode;
  className?: string;
}

export function LabelGridRow({
  columns = "auto 1fr auto",
  children,
  className = "",
}: LabelGridRowProps) {
  return (
    <li
      className={`grid items-center gap-x-4 gap-y-2 py-3 ${className}`}
      style={{ gridTemplateColumns: columns }}
    >
      {children}
    </li>
  );
}
